import { render, staticRenderFns } from "./setPassWord.vue?vue&type=template&id=cc5c6294&scoped=true&"
import script from "./setPassWord.vue?vue&type=script&lang=ts&"
export * from "./setPassWord.vue?vue&type=script&lang=ts&"
import style0 from "./setPassWord.vue?vue&type=style&index=0&id=cc5c6294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c6294",
  null
  
)

export default component.exports